import React from 'react';
import { Link } from 'react-router-dom';
import { useSupport } from '../../contexts/SupportContext';
import { brand } from '../../config/brand';

const isLight = brand.defaultTheme === 'olive';

const ft = {
  bg: isLight ? 'bg-gray-50 text-gray-600' : 'dark bg-[#0f172a] text-slate-200',
  border: isLight ? 'border-gray-200/50' : 'border-slate-800/50',
  brandText: isLight ? 'text-gray-400' : 'text-slate-400',
  heading: isLight ? 'text-gray-900' : 'text-white',
  link: isLight ? 'text-gray-500' : 'text-slate-400',
  dim: isLight ? 'text-gray-400' : 'text-slate-500',
};

export default function Footer(): JSX.Element {
  const { openSupport } = useSupport();

  return (
    <footer className={`py-16 border-t ${ft.border} ${ft.bg}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src={brand.logo} alt={brand.name} className="h-8 w-auto opacity-70" loading="lazy" />
              <span className={`text-lg font-brand tracking-tighter uppercase ${ft.brandText}`}>
                {brand.name}
              </span>
            </Link>
            <p className={`text-sm leading-relaxed ${ft.link}`}>
              {brand.tagline}.
              Publish to 8 platforms from one dashboard.
            </p>
          </div>

          {/* Product */}
          <nav aria-label="Product links">
            <h4 className={`font-bold text-sm mb-4 uppercase tracking-wider ${ft.heading}`}>Product</h4>
            <ul className={`space-y-3 text-sm ${ft.link}`}>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/login" className="hover:text-primary transition-colors">Get Started Free</Link></li>
              <li><Link to="/login" className="hover:text-primary transition-colors">Login</Link></li>
            </ul>
          </nav>

          {/* Resources */}
          <nav aria-label="Resource links">
            <h4 className={`font-bold text-sm mb-4 uppercase tracking-wider ${ft.heading}`}>Resources</h4>
            <ul className={`space-y-3 text-sm ${ft.link}`}>
              <li><Link to="/support" className="hover:text-primary transition-colors">Support Center</Link></li>
              <li><button onClick={() => openSupport()} className="hover:text-primary transition-colors">Help Desk</button></li>
              <li><a href={`mailto:${brand.email}`} className="hover:text-primary transition-colors">Contact Us</a></li>
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Legal links">
            <h4 className={`font-bold text-sm mb-4 uppercase tracking-wider ${ft.heading}`}>Legal</h4>
            <ul className={`space-y-3 text-sm ${ft.link}`}>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
            </ul>
          </nav>
        </div>

        {/* Bottom bar */}
        <div className={`pt-8 border-t ${ft.border} flex flex-col md:flex-row justify-between items-center gap-4`}>
          <p className={`text-xs font-bold ${ft.dim}`}>© 2026 {brand.name}. All rights reserved.</p>
          <p className={`text-xs ${ft.dim}`}>
            Social media manager · Publish to X, TikTok, Instagram, Threads, Bluesky &amp; more
          </p>
        </div>
      </div>
    </footer>
  );
}
